/* 🤖 this file was generated by svg-to-ts*/
export const icoLoadingLine: {
  name: 'loading-line';
  data: string;
} = {
  name: 'loading-line',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="5.5" cy="11.5" r="2.5" fill="#000" fill-opacity=".125"/><circle cx="12.5" cy="11.5" r="2.5" fill="#000" fill-opacity=".5"/><circle cx="19.5" cy="11.5" r="2.5" fill="#000"/></svg>`
};
